import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import React, { useImperativeHandle, useState } from "react";
import ModifyMedicationLogForm from "../molecules/ModifyMedicationLogForm";
import { MedicationReportModel } from "../../../services/api/types/medications/models/MedicationReportModel";

interface Ref {
  show: (medication?: MedicationReportModel) => void;
  close: () => void;
}

const ModifyMedicationLogModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [medicationState, setMedicationState] =
    useState<MedicationReportModel | null>(null);
  useImperativeHandle(ref, () => ({
    show: (medication) => {
      setMedicationState(medication ?? null);
      setShowing(true);
    },
    close: handleClose,
  }));
  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Add note"
      hasCancelButton
    >
      <ModifyMedicationLogForm
        medication={medicationState}
        onClose={handleClose}
      />
    </ReusableModal>
  );
});

ModifyMedicationLogModal.displayName = "MedicationAddNoteModal";
export { ModifyMedicationLogModal };
